module.exports = __webpack_public_path__ + "media/images/pc/stores/namba/namba_concept_01-5bd019f26a46c99351298a4a1fb89df1.jpg";